var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRequestPhoto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.506,
    height: 24.329,
    viewBox: "0 0 21.506 24.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2000",
    "data-name": "Group 2000",
    transform: "translate(355.854 -225.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4299",
    "data-name": "Path 4299",
    d: "M-345.115,422.022c1.654,0,3.31-.042,4.963.01a6.545,6.545,0,0,1,5.787,4.453.54.54,0,0,1-.065.417,12.721,12.721,0,0,1-8.267,5.26,12.815,12.815,0,0,1-11.587-3.514,16.629,16.629,0,0,1-1.476-1.716.618.618,0,0,1-.069-.5,6.619,6.619,0,0,1,6.388-4.434c1.442.023,2.884,0,4.326,0Z",
    transform: "translate(0 -182.482)",
    fill: "#8292a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4300",
    "data-name": "Path 4300",
    d: "M-277.7,236.777a5.626,5.626,0,0,1-5.572-5.613,5.685,5.685,0,0,1,5.624-5.582,5.624,5.624,0,0,1,5.57,5.615A5.679,5.679,0,0,1-277.7,236.777Z",
    transform: "translate(-67.437)",
    fill: "#8292a8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestPhoto);
export default __webpack_public_path__ + "static/media/RequestPhoto.d75760ed9b47f2596c2fb70c3576cde9.svg";
export { ForwardRef as ReactComponent };